/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import BiddingImminenceList from 'components/organisms/bidding_imminence_list';
import BiddingDesertedSearchForm from 'components/molecules/bidding_deserted_search_form';
import { GetImmminence, SearchItem } from 'store/modules/get_dados_imminence_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { States } from 'services/states';
import Select from 'react-select';
import { ImminenceState, ImminenceTypes } from 'store/modules/get_dados_imminence_store/types';
import HelpVideoModal from 'components/molecules/help_video_modal';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { StatesTypes } from 'store/modules/online_search_store/types';
import tabId from 'services/tabId';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import createTrack from 'services/actions/tracker_actions';
import OpenTutorial from 'components/atoms/open_tutorial';
import { Container } from './styles';

const IminenciaDeserta = () => {
  const dispatch = useDispatch();

  const [page, setPage] = useState<number>(1);
  const [searchItem, setSearchItem] = useState('');
  const [modalVideoOpened, setModalVideoOpened] = useState<boolean>(true);
  const [statesList, setStatesList] = useState<Array<StatesTypes>>([]);
  const [search, setSearch] = useState<boolean>(false);
  const [searchDesert, setSearchDesert] = useState<boolean>(false);

  const states_ids = statesList?.map((statesList) => statesList.value);

  const { get_imminence } = useSelector<ApplicationState, ImminenceState>(
    (state) => state.session.get_imminence,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    document.title = '';
    createTrack('Imminence - Acessou a página');
  }, []);

  useEffect(() => {
    setPage(1);
  }, [get_imminence?.view_panel]);

  useEffect(() => {
    statesList.length === 0 && searchItem === '' && !search
      ? dispatch(
          GetImmminence({
            stateImminence: get_imminence?.view_panel,
            page,
            companyId: companyId(profile),
          }),
        )
      : search
      ? setSearchDesert(true)
      : dispatch(SearchItem(searchItem, states_ids, page, get_imminence?.view_panel));
  }, [get_imminence?.view_panel, page, profile.currentCompany[tabId()]]);

  useEffect(() => {
    setPage(1);
    setModalVideoOpened(!hasCookie('modalImminencia'));
  }, []);

  useEffect(() => {
    if (modalVideoOpened) setCookie('modalImminencia', true);
  }, [modalVideoOpened]);

  const handleClick = async () => {
    dispatch(SearchItem(searchItem, states_ids, page, get_imminence?.view_panel));
  };

  const clearField = () => {
    setSearchItem('');
    setStatesList([]);
  };

  return (
    <Container>
      <div className="container-fluid big-resolutions">
        <div className="d-md-flex d-block align-items-center mb-3">
          <h4 className="mb-1 mr-3">Licitações Estratégicas</h4>
          <OpenTutorial type="modal" source="imminence" />
        </div>
        <div className="row text-center mx-0 mt-3">
          <div
            className={`col-md-4 col-12 rounded-left tab-immminence ${
              get_imminence?.view_panel === 'has_imminence' ? 'active' : 'desativada'
            }`}
            onClick={() => {
              dispatch({ type: ImminenceTypes.SHOW_PAGE, page: 'has_imminence' });
            }}
          >
            <p className="mt-4 mb-0">
              Iminência de deserta ({get_imminence?.total_imminence?.has_imminence})
            </p>
            <span>Licitações abertas e sem proposta</span>
          </div>
          <div
            className={`col-md-4 col-12 tab-immminence ${
              get_imminence?.view_panel === 'has_low_competition' ? 'active' : 'desativada'
            }`}
            onClick={() => {
              dispatch({ type: ImminenceTypes.SHOW_PAGE, page: 'has_low_competition' });
            }}
          >
            <p className="mt-4 mb-0">
              Baixa concorrência ({get_imminence?.total_imminence?.has_low_competition}){' '}
            </p>
            <span>Licitações abertas e com poucas propostas</span>
          </div>
          <div
            className={`col-md-4 col-12 rounded-right tab-immminence ${
              get_imminence?.view_panel === 'has_desert' ? 'active' : 'desativada'
            }`}
            onClick={() => {
              dispatch({ type: ImminenceTypes.SHOW_PAGE, page: 'has_desert' });
            }}
          >
            <p className="mt-4 mb-0">
              Licitações desertas ({get_imminence?.total_imminence?.has_desert})
            </p>
            <span>Licitações desertas por falta de propostas</span>
          </div>
        </div>
        {get_imminence?.view_panel !== 'has_desert' && (
          <div className="row mt-md-5 mt-4">
            <div className="col-md-4 mb-md-0 mb-2">
              <div className="input-group">
                <input
                  type="text"
                  value={searchItem}
                  onChange={(event) => setSearchItem(event.target.value)}
                  className="form-control border-right-0"
                  placeholder="Buscar item"
                />
              </div>
            </div>
            <div className="col-md-4 mb-md-0 mb-2">
              <Select
                name="StateSearch"
                isMulti
                value={statesList || ''}
                closeMenuOnSelect={false}
                onChange={(event) => setStatesList([...event])}
                options={States}
                placeholder="Selecione os Estados"
                className="basic-multi-select"
              />
            </div>
            <div className="col-md-4 d-flex justify-content-md-start justify-content-center">
              <button className="btn btn-primary mr-2" onClick={() => handleClick()} type="button">
                Buscar
              </button>
              <button
                className="btn btn-link btn-clean-search btn-sm"
                onClick={() => clearField()}
                type="button"
              >
                Limpar
              </button>
            </div>
          </div>
        )}
        {get_imminence?.view_panel === 'has_low_competition' ||
        get_imminence?.view_panel === 'has_imminence' ? (
          <BiddingImminenceList setPage={setPage} page={page} />
        ) : (
          <div className="row">
            <div className="col-md-3">
              <BiddingDesertedSearchForm
                page={page}
                setSearch={setSearch}
                searchDesert={searchDesert}
              />
            </div>
            <div className="col-md-9">
              <BiddingImminenceList setPage={setPage} page={page} />
            </div>
          </div>
        )}
        <HelpVideoModal
          modalVideoOpened={modalVideoOpened}
          setModalVideoOpened={setModalVideoOpened}
          urlVideo="https://player.vimeo.com/video/1142397313"
        />
      </div>
    </Container>
  );
};
export default IminenciaDeserta;
